import { CourseType } from '../enums/course-type.enum';

export interface CourseTypeConfig {
  label: string;
  icon: string;
}

export const COURSE_TYPE_LABELS: Record<CourseType, string> = {
  [CourseType.TRAINING]: 'Treinamento',
  [CourseType.COURSE]: 'Curso'
};

export const COURSE_TYPE_CONFIG: Record<CourseType, CourseTypeConfig> = {
  [CourseType.TRAINING]: { label: 'Treinamento', icon: 'flash_on' },
  [CourseType.COURSE]: { label: 'Curso', icon: 'school' }
};
